import { PlantWoodDensity } from "../../../../../api/types/plants";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { SelectOption } from "../../../../../types/select-option";
import { useTreeShapesData } from "../../../api/useTreeShapesData";
import { CafsVariableType } from "../../../const/cafs-variable-type";
import { renderForTree } from "../../../utils/render-for-tree";

import { boleFractionOfTotalHeightMaxFn } from "./functions/boleFractionOfTotalHeightMax";

export function useWoodDensityVariables(): CafsVariable<PlantWoodDensity>[] {
  const { treeShapes } = useTreeShapesData();
  return [
    {
      name: "WoodDensityRemarks",
      type: CafsVariableType.Remarks,
    },
    {
      name: "DensitySapWoodKgPM3",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "DensityHeartWoodKgPM3",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "YearHeartWoodStart",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "YearHeartWoodMax",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "HeartwoodMaxVolFraction",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeShapeId",
      type: CafsVariableType.Select,
      shouldRender: renderForTree,
      options: treeShapes?.map(ts => {
        return { label: ts.Name, id: ts.Id } as SelectOption;
      }),
    },
    {
      name: "BoleFractionOfTotalHeightMax",
      type: CafsVariableType.Calculated,
      shouldRender: renderForTree,
      calculationFn: boleFractionOfTotalHeightMaxFn,
      data: treeShapes,
      dependOn: ["TreeShapeId"],
    },
  ];
}
